
export class BuilderPageMenuCtrl {
  constructor(TemplateService, $scope) {
    'ngInject';
    this.$scope = $scope;
    this.ts = TemplateService;
    this.initialized = false;
  }

  async $onInit() {
    this.$scope.$watch('$ctrl.showPageContextMenu', async () => {
      this.initialized = false;
      this.setPageNumber = false;
      this.swapPages = false;
      await this.setPageNumLimits();
    });
  }

  async setPageNumLimits() {
    if (!this.showPageContextMenu) return;
    const templateData = await this.ts.getTemplateData();
    this.maxPageNum = templateData.template.partialPages.reduce((prev, current) => (prev.pageNumber > current.pageNumber) ? prev : current).pageNumber;
    this.minPageNum = templateData.template.partialPages.reduce((prev, current) => (prev.pageNumber < current.pageNumber) ? prev : current).pageNumber;
    this.origPageNumber = this.activePage.pageNumber;
    this.newPageNumber = this.activePage.pageNumber;
    this.initialized = true;
  }
}

export default {
  bindings: {
    activePage: "=",
    showPageContextMenu: "=",
    onRemovePageMenu: "&",
    onClearPageMenu: "&",
    onMovePageMenu: "&",
    onBackgroundPageMenu: "&",
    onSetPageNumMenu: "&",
  },
  controller: BuilderPageMenuCtrl,
  templateUrl: 'form-builder/builder-page-menu/builder-page-menu.component.html',
}
